import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import { AccordionItemProps } from 'src/components/accordion';
import { lang } from 'src/utils';

export const getUserItems = (
  knownCustomerError: boolean,
  onKnownUserClick: () => void,
  unknownCustomerError: boolean,
  onUnknownUserClick: () => void,
): AccordionItemProps[] => {
  return [
    {
      label: lang.thankYouComponent.unknownUser,
      onLabelClick: onUnknownUserClick,
      content: <div />,
      chevronIcon: <ArrowForwardIcon />,
      disabledExpand: true,
      hasError: unknownCustomerError,
    },
    {
      label: lang.thankYouComponent.knownUser,
      onLabelClick: onKnownUserClick,
      content: <div />,
      chevronIcon: <ArrowForwardIcon />,
      disabledExpand: true,
      hasError: knownCustomerError,
    },
  ];
};

export const getBackgroundImageItem = (
  onLabelClick: () => void,
  hasError: boolean,
) => {
  return {
    label: lang.background,
    onLabelClick,
    content: <div />,
    chevronIcon: <ArrowForwardIcon />,
    disabledExpand: true,
    hasError,
  };
};

export const getNavigationItem = (
  label: string,
  onLabelClick: (() => void) | undefined,
  hasError = false,
  disabled = false,
): AccordionItemProps => ({
  label,
  onLabelClick,
  content: <div />,
  chevronIcon: <ArrowForwardIcon />,
  disabledExpand: true,
  hasError,
  disabled,
});
